export const BASE_API_URL =
  process.env?.REACT_APP_BASE_API_URL ?? 'https://api.dev.qnous.io/api';

export const API_DOCS_URL = BASE_API_URL.replace(
  /\/api$/,
  '/testing/3c9a30c6-437e-4fd5-bdf8-3b64d82362ca/docs-json',
);

export const PDF_API_URL =
  process.env?.REACT_APP_PDF_API_URL ?? 'https://pdf.solution.qnous.io';

export const QUESTIONNAIRE_FILES_RELEASE_DATE =
  process.env?.REACT_APP_QUESTIONNAIRE_FILES_RELEASE_DATE;

export const AWS_ASSETS_URL = 'https://cdn.solution.qnous.io/organization-logo';

export const isQH = window.location.hostname.includes('qh.qnous.io');
export const isLocal = window.location.hostname.includes('localhost');

/**
 * The page origin the PDF service is told to render. The service opens this
 * URL in its own headless browser, so it must be an origin that browser can
 * reach AND that serves the code under test: a deployed service cannot reach
 * a developer's localhost (hence the dev fallback), while a service running
 * locally must render the local page or unreleased report changes become
 * untestable.
 */
export const originUrl =
  isLocal && !PDF_API_URL.includes('localhost')
    ? 'https://dev.qnous.io'
    : window.location.origin;

export const UsablePdfWidth = 680; // A4 width - 80px padding on both sides
